/*
 * Accessibility Widget — Suri (Full)
 * Hebrew RTL, WCAG 2.0 AA / IS 5568, 17 features
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'suriA11ySettings';

  var FEATURES = {
    'zoom-in':            { exclusive: ['zoom-out'] },
    'zoom-out':           { exclusive: ['zoom-in'] },
    'text-larger':        { exclusive: ['text-smaller'] },
    'text-smaller':       { exclusive: ['text-larger'] },
    'readable-font':      {},
    'fixed-descriptions': { js: true },
    'show-descriptions':  { js: true },
    'highlight-links':    {},
    'invert-colors':      { exclusive: ['high-contrast', 'black-yellow', 'sepia', 'monochrome'] },
    'black-yellow':       { exclusive: ['high-contrast', 'invert-colors', 'sepia', 'monochrome'] },
    'high-contrast':      { exclusive: ['black-yellow', 'invert-colors', 'sepia', 'monochrome'] },
    'sepia':              { exclusive: ['high-contrast', 'black-yellow', 'invert-colors', 'monochrome'] },
    'monochrome':         { exclusive: ['high-contrast', 'black-yellow', 'invert-colors', 'sepia'] },
    'no-animations':      {},
    'black-cursor':       {},
    'large-cursor':       {},
    'keyboard-mode':      {}
  };

  function loadSettings() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) { return {}; }
  }
  function saveSettings(s) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(s)); } catch (e) {}
  }

  function applySettings(settings) {
    var html = document.documentElement;
    Object.keys(FEATURES).forEach(function (feat) {
      html.classList.toggle('a11y-' + feat, !!settings[feat]);
    });
    applyImageCaptions(!!settings['fixed-descriptions']);
    setupHoverTooltips(!!settings['show-descriptions']);
  }

  window.suriA11yRestore = function () { applySettings(loadSettings()); };

  /* ---------- JS-driven: fixed image captions ---------- */
  function applyImageCaptions(enable) {
    document.querySelectorAll('.a11y-img-caption').forEach(function (el) { el.remove(); });
    if (!enable) return;
    var imgs = document.querySelectorAll('img[alt]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (!img.alt || !img.alt.trim()) continue;
      if (img.closest && img.closest('.a11y-panel')) continue;
      var span = document.createElement('span');
      span.className = 'a11y-img-caption';
      span.textContent = img.alt;
      if (img.parentNode) img.parentNode.insertBefore(span, img.nextSibling);
    }
  }

  /* ---------- JS-driven: hover tooltips ---------- */
  var tooltipEl = null;
  var hoverHandler = null;
  var leaveHandler = null;

  function setupHoverTooltips(enable) {
    if (tooltipEl) { tooltipEl.remove(); tooltipEl = null; }
    if (hoverHandler) {
      document.removeEventListener('mouseover', hoverHandler);
      document.removeEventListener('mouseout', leaveHandler);
      document.removeEventListener('focusin', hoverHandler);
      document.removeEventListener('focusout', leaveHandler);
      hoverHandler = null;
      leaveHandler = null;
    }
    if (!enable) return;

    tooltipEl = document.createElement('div');
    tooltipEl.className = 'a11y-tooltip';
    tooltipEl.style.display = 'none';
    document.body.appendChild(tooltipEl);

    hoverHandler = function (e) {
      var t = e.target;
      if (!t || t === document) return;
      if (t.closest && t.closest('.a11y-panel, .a11y-toggle, .a11y-tooltip')) return;
      var text = t.getAttribute && (t.getAttribute('title') || t.getAttribute('alt') || t.getAttribute('aria-label'));
      if (!text || !text.trim()) return;
      tooltipEl.textContent = text;
      tooltipEl.style.display = 'block';
      var rect = t.getBoundingClientRect();
      var top = rect.top - 36;
      if (top < 4) top = rect.bottom + 6;
      tooltipEl.style.top = top + 'px';
      tooltipEl.style.right = Math.max(8, window.innerWidth - rect.right) + 'px';
      tooltipEl.style.left = 'auto';
    };
    leaveHandler = function () {
      if (tooltipEl) tooltipEl.style.display = 'none';
    };
    document.addEventListener('mouseover', hoverHandler);
    document.addEventListener('mouseout', leaveHandler);
    document.addEventListener('focusin', hoverHandler);
    document.addEventListener('focusout', leaveHandler);
  }

  /* ---------- Toggling ---------- */
  function toggleFeature(feat) {
    var settings = loadSettings();
    if (settings[feat]) {
      settings[feat] = false;
    } else {
      var ex = FEATURES[feat] && FEATURES[feat].exclusive;
      if (ex) ex.forEach(function (e) { settings[e] = false; });
      settings[feat] = true;
    }
    saveSettings(settings);
    applySettings(settings);
    updateButtons(settings);
  }
  function updateButtons(settings) {
    var btns = document.querySelectorAll('.a11y-option');
    for (var i = 0; i < btns.length; i++) {
      var feat = btns[i].getAttribute('data-a11y');
      btns[i].setAttribute('aria-pressed', settings[feat] ? 'true' : 'false');
    }
  }
  function resetAll() {
    saveSettings({});
    applySettings({});
    updateButtons({});
  }

  /* ---------- Panel show/hide ---------- */
  function openPanel() {
    var panel = document.querySelector('.a11y-panel');
    var toggle = document.querySelector('.a11y-toggle');
    if (!panel || !toggle) return;
    panel.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    setTimeout(function () {
      var first = panel.querySelector('button, a, [tabindex]');
      if (first) first.focus();
    }, 30);
  }
  function closePanel() {
    var panel = document.querySelector('.a11y-panel');
    var toggle = document.querySelector('.a11y-toggle');
    if (!panel || !toggle) return;
    panel.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus();
  }

  /* ---------- Init ---------- */
  function init() {
    var toggle = document.querySelector('.a11y-toggle');
    var panel = document.querySelector('.a11y-panel');
    if (!toggle || !panel) return;

    var settings = loadSettings();
    applySettings(settings);
    updateButtons(settings);

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = panel.getAttribute('aria-hidden') === 'false';
      if (open) closePanel(); else openPanel();
    });

    var closeBtn = panel.querySelector('.a11y-panel__close');
    if (closeBtn) closeBtn.addEventListener('click', closePanel);

    var options = panel.querySelectorAll('.a11y-option');
    for (var i = 0; i < options.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          toggleFeature(btn.getAttribute('data-a11y'));
        });
      })(options[i]);
    }

    var resetBtn = panel.querySelector('.a11y-btn-reset');
    if (resetBtn) resetBtn.addEventListener('click', resetAll);

    // Auto-detect keyboard usage for focus rings (independent of the manual toggle)
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') {
        document.documentElement.classList.add('a11y-keyboard-mode');
      }
      if (e.key === 'Escape' && panel.getAttribute('aria-hidden') === 'false') {
        closePanel();
      }
    });
    document.addEventListener('mousedown', function () {
      if (!loadSettings()['keyboard-mode']) {
        document.documentElement.classList.remove('a11y-keyboard-mode');
      }
    });

    document.addEventListener('click', function (e) {
      if (panel.getAttribute('aria-hidden') === 'false' &&
          !panel.contains(e.target) && !toggle.contains(e.target)) {
        closePanel();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
